import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit, signal, ChangeDetectorRef, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, FormsModule, NgForm, NgModel, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FeedstockLoadScheduleResponse, LoadSchedulePopupInput, SaveFeedStockLoadSchedule_AdditionalStreamsRequest, SaveFeedstockLoadScheduleRequest } from '../../../interfaces/feedstocklistmodel';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ErrorStateMatcher } from '@angular/material/core';
import { LookUpService } from '../../../services/lookupservice';
import { Regions, SitesShortForm, SiteTanksResponse } from '../../../interfaces/regions';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { StreamsList } from '../../../interfaces/streamsmodel';
import { FeedstockService } from '../../../services/feedstockservice';
import { GeneratorsList, GetMarketGeneratorsResponse } from '../../../interfaces/generatorsmodel';
import { FeedstockStatus, GetDisposalMethodsBySiteIdResponse } from '../../../interfaces/feedstockstatus';
import { MaterialUnitOfMeasureLookupResponse, ORHaulerResponse } from '../../../interfaces/haulerModel';
import { FeedStockSchedulePriceMatrixRequest, IdName } from '../../../interfaces/pricematrixmodel';
import { CancelReasonResponse, FeeCategoryLookupResponse, TruckTypesResponse } from '../../../interfaces/feeCategoryLookupResponse';
import { FeedStockLoadScheduleAdditionalStreamsResponse, FeedstockLoadScheduleWithAdditionalStreamsByIdResponse } from '../../../interfaces/feedStockLoadAdditionalRevenue';
import { MatMenuModule } from '@angular/material/menu';
import { AddeditAdditionalstreamsComponent } from '../addedit-additionalstreams/addedit-additionalstreams.component';
import { AlertDialogComponent } from '../../shared/components/alert-dialog/alert-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmationDialogData, ConfirmationDialogComponent } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { forkJoin, tap } from 'rxjs';
import { SaveAttemptErrorMatcher } from '../../shared/commonutils/errorStateDirective';
import { RoleService } from '../../../services/role.service';
import { formatDateOnly, formatDateTime, normalizeNullableToString, numericInputLimit, parseSafariSafeDate } from '../../shared/commonutils/helper';
import { Key } from 'readline';
import { SaveInternalNotesComponent } from '../save-internal-notes/save-internal-notes.component';
import { MatSelectItems, RPCTypesTableType } from '../../../interfaces/lookup';
import { SelectSearchComponent } from '../../shared/components/select-search/select-search.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DatetimePickerInputComponent } from '../../shared/components/datetime-picker-input/datetime-picker-input.component';
import { AttachDocumentsComponent as DeepackAttachDocumentsComponent } from '../../deepack/attach-documents/attach-documents.component';
import { ViewDocumentsComponent } from '../view-documents/view-documents.component';
import { LoadScheduleControlFlags, ScreenName } from '../../../interfaces/securityPermissions';
import { RolePermissionsService } from '../../../services/role-permissions.service';
import { AddEditRpcComponent } from '../add-edit-rpc/add-edit-rpc.component';

@Component({
  selector: 'app-addedit-loadschedule',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,    
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatTableModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatDialogModule,
    //NgxMatSelectSearchModule,
    SelectSearchComponent,
    DragDropModule,
    DatetimePickerInputComponent 
  ],
  providers: [],
  templateUrl: './addedit-loadschedule.component.html',
  styleUrl: './addedit-loadschedule.component.scss'
})
export class AddeditLoadscheduleComponent implements OnInit, AfterViewInit {
  attemptSave = signal(false);
  public matcher = new SaveAttemptErrorMatcher(() => this.attemptSave());
  public rolesService = inject(RoleService);
  @ViewChild('sdctrl') sdctrl!: NgModel;
  @ViewChild('adctrl') adctrl!: NgModel;
  @ViewChild('cancelReasonCtrl') cancelReasonCtrl?: NgModel;
  @ViewChild('tankCtrl') tankCtrl?: NgModel;
  task: string = 'Add';
  showDocsButtons: boolean = false;
  hasDocumentAttached: boolean = false;
  screenName: string = 'AD';
  workOrderNumber: string = '';
  showSaveButton: boolean = true;
  disableControls: boolean = false;
  scheduleId: number = 0;
  markets: Regions[] = [];
  filteredMarkets: Regions[] = [];
  generators: GetMarketGeneratorsResponse[] = [];
  filteredGenerators: GetMarketGeneratorsResponse[] = [];
  streams: StreamsList[] = [];
  filteredstreams: StreamsList[] = [];
  disposalSites: SitesShortForm[] = [];
  filtereddisposalSites: SitesShortForm[] = [];
  haulers: ORHaulerResponse[] = [];
  filteredhaulers: ORHaulerResponse[] = [];
  tanks: SiteTanksResponse[] = [];
  uoms: MaterialUnitOfMeasureLookupResponse[] = [];
  ruoms: MaterialUnitOfMeasureLookupResponse[] = [];
  fsStatusList: FeedstockStatus[] = [];
  feeCategories: FeeCategoryLookupResponse[] = [];
  filteredFeeCategories: FeeCategoryLookupResponse[] = [];
  truckTypes: TruckTypesResponse[] = [];
  cancelReasons: CancelReasonResponse[] = [];
  disposalMethods: GetDisposalMethodsBySiteIdResponse[] = [];
  editresponse!: FeedstockLoadScheduleWithAdditionalStreamsByIdResponse;
  internalSiteHaulCostReasons: IdName[] = [];
  filteredInternalSiteHaulCostReasons: IdName[] = [];
  displayValue = signal<string>('');
  minDate = new Date();
  selectStatusItems: MatSelectItems[] = [];
  selectSiteItems: MatSelectItems[] = [];
  selectHaulerItems: MatSelectItems[] = [];
  selectCustomerItems: MatSelectItems[] = [];
  selectStreamItems: MatSelectItems[] = [];
  selectMarketItems: MatSelectItems[] = [];
  displayedAdditionalStreamColumns: string[] = ['actions', 'streamName', 'uom', "quantity", 'tipFee', 'aD_RebateUOMText', 'aD_RebateQty', 'rebateValue', 'tons'];
  additionalStreamsDataSource = new MatTableDataSource<FeedStockLoadScheduleAdditionalStreamsResponse>([]);
  rpcTypesData: RPCTypesTableType[] = [];
  @ViewChild('closeButton', { static: false }) closeButton!: ElementRef;

  id: number | null = null;
  taskId: string = 'Add';
  stid: string | null = null;
  siteTypeId: string | null = null;
  marketId: string | null = '-1';
  generatorId: number | null = null;
  streamId: number | null = null;
  disposalSiteId: string | null = null;
  haulerId: string | null = null;
  tankId: number | null = null;
  truckId: number | null = null;
  uomId: number | null = null;
  ruomId: number | null = null;
  projectedVolume: number | null = null;
  actualTons: number | null = null;
  prevprojectedVolume: number | null = null;
  actualDate: Date | null = null;
  prevActualDate: Date | null = null;
  preAcceptedActualDate: Date | null = null;
  scheduleDate: Date | null = null;
  tipFee: number | null = null;
  feeCategoryId: number | null = null;
  feeCategoryIds: number[] = [];
  haulRevenue: number | null = null;
  flatFee: number | null = null;
  haulFee: number | null = null;
  haulingExpense: number | null = null;
  statusId: number | null = 9;
  prevStatusId: number | null = 0;
  actualQuantity: number | null = null;
  rebateQuantity: number | null = null;
  rebateValue: number | null = null;
  driverName: string = '';
  loadSlipNumber: number | null = null;
  trailerNumber: string = '';
  customerReferenceNo: string = '';
  internalNotes: string = '';
  schedulingNotes: string = '';
  notesForHauler: string = '';
  notesForCustomer: string = '';
  notesForDisposalSite: string = '';
  codNotes: string = '';
  holdLoadOnComplete: boolean = false;
  isPriceMatrixAvailable: boolean = false;
  canOpenAdditionalStreams: boolean = false;
  isProjectedQuantityEnabled: boolean = true;
  isActualQuantityEnabled: boolean = true;
  isActualTonsEnabled: boolean = false;
  isFlatFeeDisabled: boolean = true;
  isRebateDisabled: boolean = true;
  projectedQuantityMin: number = 0;
  disposalMethodId: number | null = null;
  internalSiteHaulCostReasonId: number | null = null;
  seal: string | null = null;
  bol: string | null = null;
  truck_Number: string | null = null;
  isInvoiceReqForCancelledLoad: boolean | null = null;
  cancelReasonId: number | null = null;
  cancelReasonNotes: string | null = null;
  showCancelRow: boolean = false;
  divertedLoad: boolean | null = false;
  priceMatrixId: number | null = null;
  enableAddtStreamsGridControls: boolean = false;
  enableAddtStreamsAddButon: boolean = false;
  isInvoiceReqForCancelledLoadDisabled: boolean = true;
  internalSiteHaulCostReasonIdDisabled: boolean = true;
  tipFeeCtrlDisabled: boolean = true;
  feeCategoryCheckNeeded: boolean = false;
  isActualQuantityDisabled: boolean = false;
  isProjectedQtyDisabled: boolean = false;
  showOnlyStatusDropdown: boolean = false;
  showNotesPopupLink: boolean = false;
  disableSCWorkOrder: boolean = true;
  scWorkOrder: Number | null = null;
  roleNames: string = "";
  prevFeeCategoryIds: number[] = [];

  // Environment Fee constants for readability
  private readonly FEE_LTL = 7;
  private readonly FEE_FTL = 8;
  ctrlpermissions: LoadScheduleControlFlags;
  get isTankRequired(): boolean {
    return this.siteTypeId === null || this.siteTypeId === '1';
  }
  constructor(
    private cdr: ChangeDetectorRef,
    private lookUp: LookUpService,
    private feedstockService: FeedstockService,
    public dialogRef: MatDialogRef<AddeditLoadscheduleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoadSchedulePopupInput,
    private permService: RolePermissionsService,
    private dialog: MatDialog
  ) {
    console.log("incoming data", this.data);
    this.roleNames = this.rolesService.getRolesAsString();
    this.scheduleId = this.data.scheduleTypeId;
    this.id = this.data.fsLoadId;
    this.task = this.data.task;
    this.screenName = this.data.screenName;
    this.showSaveButton = this.data.showSaveButton;
    this.disableControls = this.data.disableControls;
    this.ctrlpermissions = this.data.ctrlpermissions ?? new LoadScheduleControlFlags();
    if (this.task == 'Add') {
      this.actualDate = new Date();
    }
    if (this.scheduleId == 2 || this.scheduleId == 4) {
      if (this.task == 'Add') {
        this.actualDate = new Date();
        this.scheduleDate = new Date();
      }
    }
    if (this.scheduleId == 2 || this.scheduleId == 4) {
      this.isActualQuantityEnabled = false;
    }
    this.showOnlyStatusDropdown = this.data.editStatusButton;
    this.showNotesPopupLink = this.data.showNotesPopuplink;
    if(this.task === "Edit"){
      this.showDocsButtons = true;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      try {
        if (this.closeButton) {
          this.closeButton.nativeElement.blur();
        }
      } catch (error) { }
    }, 0);
  }

  ngOnInit(): void {
    this.loadDropdownData();
  }

  loadDropdownData() {
    const sources: any = {
      markets: this.getMarketsData(),
      haulers: this.getHaulers(),
      uom: this.getUnitsOfmeasureData(),
      fees: this.getFeeCategories(),
      status: this.getFSStatus(),
      permissions: this.getControlPermissions()
    };
    if (this.scheduleId != 1) {
      sources.truckTypes = this.getTruckTypes();
    }
    forkJoin(sources).subscribe({
      next: (results: any) => {
        if (this.task === 'Edit' || this.task === 'Duplicate') {
          this.feedstockService.getFeedStockLoadByid(this.id, this.scheduleId).subscribe({
            next: (response) => {
              this.editresponse = { ...response };
              this.loadDataOnEditOrDuplicate(response);
            }
          });
        }
      }
    });
  }

  openInternalNotesPopup() {
    const dialogRef = this.dialog.open(SaveInternalNotesComponent, {
      maxWidth: '400px',
      disableClose: true,
      data: {
        title: 'Internal Notes',
        ipData: this.editresponse,
        workorderno: this.workOrderNumber,
        scheduleTypeId: this.scheduleId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (this.scheduleId == 4) {
          this.schedulingNotes = result;
        } else {
          this.internalNotes = result;
        }
      }
    });
  }

  loadDataOnEditOrDuplicate(response: FeedstockLoadScheduleWithAdditionalStreamsByIdResponse) {
    console.log("edit or dup mode data", response);
    this.id = this.task == 'Duplicate' ? 0 : response.feedstockLoadSchedule.id;
    if (response.feedstockLoadSchedule.actualDate) {
      this.actualDate = new Date(response.feedstockLoadSchedule.actualDate);
      this.prevActualDate = new Date(response.feedstockLoadSchedule.actualDate);
    } else {
      this.actualDate = null;
      this.prevActualDate = null;
    }
    this.marketId = response.feedstockLoadSchedule.market <= 0 ? '-1' : `${response.feedstockLoadSchedule.market}`;
    this.getGeneratorsByMarketId(this.marketId, false);
    this.workOrderNumber = response.feedstockLoadSchedule.workOrderNumber;
    this.generatorId = Number(response.feedstockLoadSchedule.generatorId);
    this.onGeneratorSelectionChange(this.generatorId, false);
    this.streamId = Number(response.feedstockLoadSchedule.feedstockStreamId);
    this.onStreamSelectionChange(this.streamId, false);
    this.disposalSiteId = response.feedstockLoadSchedule.siteID;
    this.onSiteChange(this.disposalSiteId, false);
    this.haulerId = response.feedstockLoadSchedule.haulerId;
    this.tankId = response.feedstockLoadSchedule.tankId;
    this.uomId = response.feedstockLoadSchedule.unitOfMeasure;
    this.projectedVolume = response.feedstockLoadSchedule.projected_Quantity;

    //this.tipFee = response.feedstockLoadSchedule.tipFee;

    if(this.tipFee !== null && this.tipFee >= 0){      
      this.isPriceMatrixAvailable = true;
    }
    this.haulFee = response.feedstockLoadSchedule.haul_Rate_Perload;
    this.haulRevenue = response.feedstockLoadSchedule.haul_Rate_Perload;
    this.getPriceMatrixTipFee();
    this.statusId = this.task === 'Duplicate' ? 9 : response.feedstockLoadSchedule.status;
    this.flatFee = response.feedstockLoadSchedule.flatFee == 0 ? null : response.feedstockLoadSchedule.flatFee;

    if (response.feedstockLoadSchedule.status == 2 || response.feedstockLoadSchedule.status == 3
      || response.feedstockLoadSchedule.status == 5) {
      this.isInvoiceReqForCancelledLoadDisabled = false;
    } else {
      this.isInvoiceReqForCancelledLoadDisabled = true;
    }

    this.feeCategoryId = response.feedstockLoadSchedule.feeCategory;
    this.feeCategoryIds = response.feedstockLoadSchedule.feeCategories === null
      ? []
      : response.feedstockLoadSchedule.feeCategories.split(',').map(id => Number(id));

    if (this.scheduleId == 1) {
      this.prevFeeCategoryIds = [...this.feeCategoryIds];
      this.onFeeCategoriesChange(this.feeCategoryIds);
    } else {
      this.onFeeCategoryChange(this.feeCategoryId);
    }
    this.streamId = Number(response.feedstockLoadSchedule.feedstockStreamId);
    this.disposalSiteId = response.feedstockLoadSchedule.siteID;
    this.haulerId = response.feedstockLoadSchedule.haulerId;
    this.tankId = response.feedstockLoadSchedule.tankId == 0 ? null : response.feedstockLoadSchedule.tankId;
    this.uomId = response.feedstockLoadSchedule.unitOfMeasure;
    //this.getUnitsOfmeasureData();
    this.projectedVolume = response.feedstockLoadSchedule.projected_Quantity;

    this.actualQuantity = this.task == 'Duplicate' ? null : response.feedstockLoadSchedule.actual_Quantity;
    this.rebateQuantity = response.feedstockLoadSchedule.rebateQty;
    this.ruomId = response.feedstockLoadSchedule.rebateUOM;
    this.rebateValue = response.feedstockLoadSchedule.rebateValue;
    this.driverName = this.task == 'Duplicate' ? '' :response.feedstockLoadSchedule.driver;
    this.loadSlipNumber = (this.task == 'Duplicate' || response.feedstockLoadSchedule.loadSlipNumber == 0) ? null :response.feedstockLoadSchedule.loadSlipNumber;
    this.trailerNumber = this.task == 'Duplicate' ? '' :response.feedstockLoadSchedule.trailer_Number;
    this.customerReferenceNo = this.task == 'Duplicate' ? '' :response.feedstockLoadSchedule.customerReferenceNo;
    this.internalNotes = this.task == 'Duplicate' ? '' : response.feedstockLoadSchedule.internalNotes;
    this.notesForHauler = this.task == 'Duplicate' ? '' :response.feedstockLoadSchedule.notesForHauler;
    this.notesForCustomer = this.task == 'Duplicate' ? '' : response.feedstockLoadSchedule.notesForCustomer;
    this.codNotes = this.task == 'Duplicate' ? '' : response.feedstockLoadSchedule.codNotes;
    this.actualQuantity = this.task == 'Duplicate' ? null : response.feedstockLoadSchedule.actual_Quantity;
    this.actualTons = this.task == 'Duplicate' ? null : response.feedstockLoadSchedule.actual_Volume_Tons;
    if (response.feedstockLoadSchedule.scheduleDate) {
      this.scheduleDate = new Date(response.feedstockLoadSchedule.scheduleDate);
    } else {
      this.scheduleDate = null;
    }
    this.schedulingNotes = response.feedstockLoadSchedule.schedulingNotes;
    this.truckId = response.feedstockLoadSchedule.truckType;
    //this.isRebateEligible = response.feedstockLoadSchedule.isRebateEligible;
    this.disposalMethodId = response.feedstockLoadSchedule.disposalMethodId;
    this.additionalStreamsDataSource.data = this.task === 'Duplicate'
        ? response.feedStockLoadScheduleAdditionalStreams.map(s => ({
              ...s,
              id:       0,
              fSLoadID: 0
          }))
        : response.feedStockLoadScheduleAdditionalStreams;

    if (this.scheduleId != 1) {
      this.isActualQuantityEnabled = this.uomId == 2;
    }
    this.cancelReasonId = this.task == 'Duplicate' 
          ? null
          : response.feedstockLoadSchedule.cancelReasonId == 0 ? null : response.feedstockLoadSchedule.cancelReasonId;
    this.cancelReasonNotes = this.task == 'Duplicate' ? null :response.feedstockLoadSchedule.cancelReasonNotes;
    this.holdLoadOnComplete = response.feedstockLoadSchedule.holdLoadOnComplete || false;
    this.seal = this.task == 'Duplicate' ? null :response.feedstockLoadSchedule.seal;
    this.bol = this.task == 'Duplicate' ? null :response.feedstockLoadSchedule.bol;
    this.truck_Number = this.task == 'Duplicate' ? null :response.feedstockLoadSchedule.truck_Number;
    this.isInvoiceReqForCancelledLoad = response.feedstockLoadSchedule.isInvoiceReqForCancelledLoad;
    this.notesForDisposalSite = this.task == 'Duplicate' ? 'null' :response.feedstockLoadSchedule.notesForDisposalSite;
    this.internalSiteHaulCostReasonId = response.feedstockLoadSchedule.internalSiteHaulCostReason;
    if (!this.tipFeeCtrlDisabled) {
      this.tipFee = response.feedstockLoadSchedule.tipFee;
    }
    this.onStatusChange(this.statusId);
    this.priceMatrixId = this.priceMatrixId ?? response.feedstockLoadSchedule.priceMatrixId;
    this.divertedLoad = response.feedstockLoadSchedule.divertedLoad;
    this.scWorkOrder = response.feedstockLoadSchedule.scWorkOrderNo;
    this.haulingExpense = response.feedstockLoadSchedule.haulingExpense;

    this.rpcTypesData = this.task === 'Duplicate'
      ? response.rpcTypesWithCount.map(s => ({...s, id: 0 }))
      : response.rpcTypesWithCount;
    //this.getHaulingExpense();
  }

  onMarketSelectionChange(marketId: string | null, manualChange: boolean): void {
    this.getGeneratorsByMarketId(marketId == null ? "-1" : marketId, manualChange);
  }

  onGeneratorSelectionChange(selectedId: number, manualChange: boolean): void {
    if (manualChange) {
      this.streamId = null;
      this.disposalSiteId = null;
      this.haulerId = null;
      this.uomId = null;
      this.tipFee = null;
      this.haulRevenue = null;
      this.projectedVolume = null
    }
    if (selectedId === null) {
      this.streamId = null;
      this.streams = [];
      this.filteredstreams = [];
    } else {
      this.getStreamsByGeneratorId(`${selectedId}`, `${this.scheduleId}`, manualChange);
      if (this.scheduleId == 2 || this.scheduleId == 4) {
        if (selectedId === 126) {
          this.projectedQuantityMin = -99999;
        } else {
          this.projectedQuantityMin = 0;
        }
      }

      if (selectedId === 128) {
        this.internalSiteHaulCostReasonIdDisabled = false;
      } else {
        this.internalSiteHaulCostReasonIdDisabled = true;
        this.internalSiteHaulCostReasonId = null;
      }
      //console.log("generator id ", selectedId, " is tip fee required? ", this.generators.find(gen => gen.id === selectedId)?.isTipFeeRequired);
      //let isTipFeeReq = this.generators.find(gen => gen.id === selectedId)?.isTipFeeRequired ?? false;
      //let envFlag = this.generators.find(gen => gen.id === selectedId)?.environment_Fee_Flag ?? false;
    }
    let walmartCustomer = this.generators.filter(i => i.customerName.trim().toLocaleLowerCase().startsWith("walmart"));
    if (walmartCustomer != null && walmartCustomer.length > 0) {
      if (walmartCustomer[0].id == selectedId) {
        const enableScWorkOrder = this.roleNames.includes('WIA') || this.roleNames.includes('GSU');
        this.disableSCWorkOrder = enableScWorkOrder ? false : true;
      }else{
        this.disableSCWorkOrder = true;
        this.scWorkOrder = null;
      }
    }else{
      this.disableSCWorkOrder = true;
      this.scWorkOrder = null;
    }
  }

  onStreamSelectionChange(selectedId: number | null, manualChange: boolean): void {
    if (manualChange) {
      // this.disposalSiteId = null;
      // this.haulerId = null;
      this.uomId = null;
      this.tipFee = null;
      this.haulRevenue = null;
      this.projectedVolume = null
    }
    if (selectedId === null) {
      this.disposalSiteId = null;
      this.disposalSites = [];
      this.filtereddisposalSites = [];
    } else {
      if(manualChange){
        const foundStream = this.streams.find(i => i.streamId == this.streamId);
        this.projectedVolume = foundStream?.projectedVolume ?? null;
        if(foundStream?.haulerId != null){
          this.haulerId = "MH-".concat(foundStream.haulerId.toString());
        }
      }

      this.getDisposalSitesByGenAndStream(this.generatorId == null ? "0" : this.generatorId.toString(),
        this.streamId == null ? "0" : this.streamId.toString(),
        this.scheduleId, this.actualDate === null ? null : this.actualDate.toISOString(), manualChange);
    }
  }

  onSiteChange(selectedId: string | null, manualChange: boolean): void {
    if (manualChange) {
      //this.haulerId = null;
      //this.selectHaulerItems = [];
      //this.haulers = [];
      this.tankId = null;
      this.tanks = [];
      if(this.task !== 'Edit' && this.task !== 'Duplicate'){
        this.uomId = null;
      }
      this.tipFee = null;
      this.haulRevenue = null;
      this.cdr.detectChanges();
    }
    if (this.disposalSiteId === null || this.disposalSiteId === 'VRS-') {
      //this.haulerId = null;
      this.tankId = null;
      //this.filteredhaulers = [];
      //this.haulers = [];
    } else {
      this.lookUp.getSiteTanksBySiteId(`${this.disposalSiteId}`).subscribe({
        next: async (response) => {
          this.tanks = response;
          this.setTank();
          this.getDisposalMethods();
          //this.getHaulers().subscribe();
        }
      });
    }
  }

  getStreamsByGeneratorId(genId: string, schedType: string, manualChange: boolean) {
    this.feedstockService.getStreamDropdownList(genId).subscribe({
      next: async (response) => {
        console.log("Streams resp", response);
        this.streams = response;
        this.filteredstreams = [...this.streams];
        this.canOpenAdditionalStreams = response.length > 1;
        this.selectStreamItems = this.streams.map(item => ({
          id: item.streamId!,
          name: item.name!,
          disabled: item.metalStatus === 'Fail',
          itemCssClass: item.metalStatus === 'Fail' ? 'stream-metal-fail' : ''
        }));
      }
    })
  }

  getMarketsData() {
    return this.lookUp.getMarketsList("").pipe(
      tap((response) => {
        console.log("market resp", response);
        this.markets = response;
        this.filteredMarkets = [...this.markets];
        this.getGeneratorsByMarketId(this.marketId ?? '-1', true);
        this.getInternalSiteHaulCostReasons();
        this.selectMarketItems = this.markets.map(item => ({
          id: item.id!,
          name: item.regionName!
        }));
      }
      ));
  }

  onMarketReceived(event: number | null) {
    console.log("market received", event?.toString())
    this.marketId = event?.toString() ?? '-1';
    this.getGeneratorsByMarketId(this.marketId, true);
  }

  onCustomerReceived(event: number | null) {
    this.generatorId = event ?? 0;
    this.onGeneratorSelectionChange(this.generatorId, true);
  }

  onSiteReceived(event: number | null) {
   
    this.disposalSiteId = event != null ? "VRS-".concat(event?.toString() ?? '') : null;
    const selectedSite = this.disposalSites.find(s => s.id === event);
    this.siteTypeId = selectedSite?.siteType?.toString() ?? null;
    this.onSiteChange(this.disposalSiteId, true);
    this.getPriceMatrix();
    this.getHaulingExpense();
  }

  onHaulerReceived(event: number | null) {
    this.haulerId =  (event && event > 0) ? "MH-".concat(event?.toString() ?? '') : null;
    this.getPriceMatrix();
    this.getHaulingExpense();
  }

  onStreamReceived(event: number | null) {
    this.streamId = event;
    this.onStreamSelectionChange(this.streamId, true);
  }

  onDateReceivedChangedEvent(event: any){
    this.actualDate = event;
    this.getPriceMatrix();
    this.getHaulingExpense();
  }

  getGeneratorsByMarketId(marketId: string, manualChange: boolean) {
    this.feedstockService.getmarketGenerators(parseInt(marketId), false).subscribe({
      next: async (response) => {
        this.generators = response;
        // console.log("generators ", this.generators);
        this.filteredGenerators = [...this.generators];
        this.selectCustomerItems = this.generators.map(item => ({
          id: item.id!,
          name: item.customerName!
        }));
      }
    })
  }

  getUnitsOfmeasureData() {
    {
      let lookUpId = this.scheduleId == 1 ? 1 : 0;
      return this.lookUp.getMaterialUnitOfMeasureLookup(lookUpId).pipe(
        tap((response) => {
          console.log("uoms", response);
          this.uoms = response;
          this.ruoms = [...this.uoms];
        })
      )
    }
  }

  getFeeCategories() {
    return this.lookUp.feeCategories().pipe(
      tap((response) => {
        console.log("fee categories", response);
        this.feeCategories = response;
        this.filteredFeeCategories = [...this.feeCategories];
      })
    )
  }

  getControlPermissions(){
    const screenNameMap: Record<number, string> = {
      1: ScreenName.AD,
      2: ScreenName.ORA,
      4: ScreenName.Strategic
    };
    let screenName = screenNameMap[this.scheduleId];
    return this.permService.getRolePermissionsNew(this.roleNames, screenName, this.id).pipe(
      tap((response) => {
        console.log("control permissions", response);
        this.applyPermissionsToForm(response);
        this.cdr.detectChanges();
      })
    )  
  }

  getFSStatus() {
    let userroles = this.rolesService.getRolesAsString();
    console.log("user roles for fs status", userroles);
    return this.feedstockService.getFeedStockStatuses(userroles).pipe(
      tap((response) => {
        console.log("feedstock status", response);
        this.fsStatusList = response;
        this.getCancelReasons();
      })
    )
  }

  getTruckTypes() {
    return this.lookUp.getTruckTypes().pipe(
      tap((response) => {
        this.truckTypes = response;
      })
    )
  }

  getCancelReasons() {
    this.lookUp.getCancelReasons().subscribe({
      next: async (response) => {
        this.cancelReasons = response;
      }
    })
  }

  getDisposalMethods() {
    var siteno = this.disposalSiteId == null ? '0' : this.disposalSiteId.split('-')[1];
    if (this.scheduleId === 4) {
      this.lookUp.getDisposalMethods(siteno).subscribe({
        next: async (response) => {
          this.disposalMethods = response;
          var streamDisposalData = this.streams.find(i => i.streamId == this.streamId);
          if (streamDisposalData && streamDisposalData.disposalMethod) {
            var streamDat = {
              id: streamDisposalData.disposalMethodId ?? 0,
              disposalMethod: streamDisposalData.disposalMethod
            };

            var itemExists = this.disposalMethods.some(item => item.disposalMethod === streamDat.disposalMethod)
            if (!itemExists) {
              this.disposalMethods.push(streamDat);
            }
          }
        }
      })
    } else {
      this.lookUp.getAllDisposalMethods().subscribe({
        next: async (response) => {
          this.disposalMethods = response;
          if (this.task === "Add" && this.scheduleId === 2) {
            this.disposalMethodId = this.disposalMethods.find(item => item.disposalMethod === "Anaerobic Digestion")?.id ?? null;
          }
          if (this.task !== "Add" && this.scheduleId === 2) {
            if (this.disposalMethodId === null) {
              this.disposalMethodId = this.disposalMethods.find(item => item.disposalMethod === "Anaerobic Digestion")?.id ?? null;
            }
          }
        }
      })
    }
  }

  getHaulers() {
    return this.lookUp.getHaulers(this.marketId ?? '-1').pipe(
      tap((response) => {
        console.log("hauler", response);
        this.haulers = response;
        this.filteredhaulers = [...this.haulers];
        this.selectHaulerItems = this.haulers.map(item => ({
          id: item.id!,
          name: item.name!
        }));
      }
      ));
  }

  getInternalSiteHaulCostReasons() {
    this.lookUp.getInternalSiteHaulCostReasons().subscribe({
      next: async (response) => {
        this.internalSiteHaulCostReasons = response;
        this.filteredInternalSiteHaulCostReasons = [...this.internalSiteHaulCostReasons];
      }
    })
  }

  getDisposalSitesByGenAndStream(generatorId: string, streamId: string, scheduleTypeId: number,
    actualDate: string | null, manualChange: boolean) {
    this.lookUp.getDisposalSitesFromPriceMatrixLookup(generatorId, streamId, scheduleTypeId.toString(), actualDate).subscribe({
      next: async (response) => {
        console.log("Disposal Sites", response);
        this.disposalSites = response;
        this.filtereddisposalSites = [...this.disposalSites];
        this.selectSiteItems = this.disposalSites.map(item => ({
          id: item.id!,
          name: item.siteName!
        }));
        if (this.disposalSiteId) {
          const siteIdNum = Number(this.disposalSiteId.split('-')[1]);
          const match = this.disposalSites.find(s => s.id === siteIdNum);
          if (match) {
            this.siteTypeId = match.siteType?.toString() ?? null;
          }
        }

        if(manualChange){
          this.getPriceMatrix();
          this.getHaulingExpense();
        }
      }
    })
  }

  setTank() {
    if (this.disposalSiteId != "" && (this.tankId == 0 || this.tankId == null)) {
      if (this.disposalSiteId == "VRS-1" || this.disposalSiteId == "VRS-3" ||
        this.disposalSiteId == "VRS-5" || this.disposalSiteId == "VRS-6" || this.disposalSiteId == "VRS-7") {
        this.tankId = 6;
      }
    }
  }

  getPriceMatrixTipFee() {
    if (this.generatorId === null || this.streamId === null || this.disposalSiteId === null || this.haulerId === null) {
      this.isPriceMatrixAvailable = false;
      this.tipFee = null;
      this.uomId = null;
      this.ruomId = null;
      this.haulRevenue = null;
      //this.projectedVolume = null;
      return;
    }
    let dtReceived = formatDateOnly(this.actualDate);
    var input: FeedStockSchedulePriceMatrixRequest = {
      customerId: this.generatorId ?? -1,
      streamId: this.streamId ?? 0,
      siteId: `${this.disposalSiteId}`,
      haulerId: Number(this.haulerId?.split('-')[1]),
      dateReceived: dtReceived ?? ''
    }
    console.log("price matrix input", input);
    this.feedstockService.getPriceMatrix(input).subscribe({
      next: async (response) => {
        if (response == null) {
          this.isPriceMatrixAvailable = false;
          this.tipFee = null;
          this.ruomId = null;
          this.haulRevenue = null;
        } else {
          this.isPriceMatrixAvailable = true;
          this.priceMatrixId = response.id;
          this.tipFee = response == null ? null : response.tipFee;
          if (this.scheduleId != 1) {
            this.uomId = response == null ? null : response.tipFee_UOM;
            this.ruomId = response == null ? null : response.rebate_UOM;

            let uomName = this.uoms.find(u => u.id === this.uomId)?.name;
            if (uomName === null || uomName === undefined) {
              this.uomId = null;
            }
          }
          this.haulRevenue = response == null ? null : response.haul_Rate_Perload;
          this.haulFee = response == null ? null : response.haul_Rate_Perload;
          this.rebateValue = response == null ? null : response.rebateValue;
          if (this.ruomId !== null && this.ruomId !== undefined && this.ruomId > 0) {
            this.isRebateDisabled = false;
          } else {
            this.isRebateDisabled = true;
          }
        }
        console.log("tip fee Price matrix", response);
        if ((this.scheduleId != 1) && this.uomId === 2) {
          this.isActualQuantityDisabled = true;
        } else {
          this.isActualQuantityDisabled = false;
        }
      }
    })
  }

  getPriceMatrix() {
    if (this.generatorId === null || this.streamId === null || this.disposalSiteId === null || this.haulerId === null) {
      this.isPriceMatrixAvailable = false;
      this.tipFee = null;
      this.uomId = null;
      this.ruomId = null;
      this.haulRevenue = null;
      //this.projectedVolume = null;
      return;
    }
    var input: FeedStockSchedulePriceMatrixRequest = {
      customerId: this.generatorId ?? -1,
      streamId: this.streamId ?? 0,
      siteId: `${this.disposalSiteId}`,
      haulerId: Number(this.haulerId?.split('-')[1]),
      dateReceived: formatDateOnly(this.actualDate) ?? ''
    }
    console.log("price matrix input", input);
    this.feedstockService.getPriceMatrix(input).subscribe({
      next: async (response) => {
        if (response == null) {
          this.isPriceMatrixAvailable = false;
          this.priceMatrixId = null;
          this.tipFee = null;
          if (this.task !== 'Edit' && this.task !== 'Duplicate') {
            this.uomId = null;
          }
          this.ruomId = null;
          this.haulRevenue = null;
          if (this.task !== 'Edit' && this.task !== 'Duplicate') {
            //this.projectedVolume = null
          }
        } else {
          this.priceMatrixId = response.id;
          this.isPriceMatrixAvailable = true;
          this.tipFee = response == null ? null : response.tipFee;
          if (this.scheduleId == 1){
            if(this.task !== 'Edit' && this.task !== 'Duplicate'){
              this.uomId = response == null ? null : response.tipFee_UOM;
            }
          }else{
            this.uomId = response == null ? null : response.tipFee_UOM;
          }
          this.ruomId = response == null ? null : response.rebate_UOM;

          let uomName = this.uoms.find(u => u.id === this.uomId)?.name;
          if (uomName === null || uomName === undefined) {
            if (this.scheduleId == 1){
              if(this.task !== 'Edit' && this.task !== 'Duplicate'){
                this.uomId = null;
              }
            }
          }
          if (this.projectedVolume == 0 || this.projectedVolume == null) {
            //this.projectedVolume = response == null ? null : response.projectedVolume;
          }

          this.haulRevenue = response == null ? null : response.haul_Rate_Perload;
          this.haulFee = response == null ? null : response.haul_Rate_Perload;
          this.rebateValue = response == null ? null : response.rebateValue;
          if (this.scheduleId == 4) {
            if (this.task !== "Add") {
              this.isActualQuantityEnabled = this.uomId == 2;
            }
          }
          if (this.ruomId !== null && this.ruomId !== undefined && this.ruomId > 0) {
            this.isRebateDisabled = false;
          } else {
            this.isRebateDisabled = true;
          }
        }
        console.log("Price matrix", response);
        if ((this.scheduleId != 1) && this.uomId === 2) {
          this.isActualQuantityDisabled = true;
        } else {
          this.isActualQuantityDisabled = false;
        }
      }
    })
  }

  getHaulingExpense() {
    if (this.generatorId === null || this.streamId === null || this.disposalSiteId === null || this.haulerId === null) {
      return;
    }
    var input: FeedStockSchedulePriceMatrixRequest = {
      customerId: this.generatorId ?? -1,
      streamId: this.streamId ?? 0,
      siteId: `${this.disposalSiteId}`,
      haulerId: Number(this.haulerId?.split('-')[1]),
      dateReceived: formatDateOnly(this.actualDate) ?? ''
    }
    console.log("haul expense input", input);
    this.feedstockService.getHaulingExpense(input).subscribe({
      next: async (response) => {
        console.log("Haul expense resp:", response);
        if (response == null) {
          this.haulingExpense = null;
        } else {
          this.haulingExpense = response;
        }
      }
    });
  }

  parseMhId(raw: string | null): number | null{
    if(!raw) return null;
    let numeric = parseInt(raw.replace('MH-', '').trim(), 10);
    return isNaN(numeric) || numeric <= 0 ? null : numeric;
  }

  onSave(): void {
    this.attemptSave.set(true);

    const isDropdownsValid = this.scheduleId == 1
      ? !!(this.generatorId && this.streamId && this.disposalSiteId && this.haulerId && this.uomId
          && (!this.isTankRequired || this.tankId))
      : !!(this.generatorId && this.streamId && this.disposalSiteId && this.haulerId);
      
    if (!isDropdownsValid) {
      if (this.scheduleId == 1 && this.isTankRequired && !this.tankId) {
        this.tankCtrl?.control.markAsTouched();
        this.tankCtrl?.control.updateValueAndValidity({ emitEvent: true });
      }
      this.cdr.detectChanges();
      this.scrollToFirstInvalidControl();
      return;
    }
    
    let hid = this.parseMhId(this.haulerId);
    if(hid === null || hid <= 0){
      this.haulerId = null;
      this.cdr.detectChanges();
      this.scrollToFirstInvalidControl();
      //this.notificationService.show('Please select a valid Hauler.', 'warning');
      return;
    }

    const isCancelledStatus = this.statusId == 2 || this.statusId == 3 || this.statusId == 5;
    if (isCancelledStatus && !this.cancelReasonId) {
      this.cancelReasonCtrl?.control.markAsTouched();
      this.cancelReasonCtrl?.control.updateValueAndValidity({ emitEvent: true });
      this.cdr.detectChanges();
      this.scrollToFirstInvalidControl();
      return;
    }

    if (!this.internalSiteHaulCostReasonIdDisabled && !this.internalSiteHaulCostReasonId) {
      this.cdr.detectChanges();
      this.scrollToFirstInvalidControl();
      return;
    }

    if (!this.isPriceMatrixAvailable) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'Price matrix is not available.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }

    if (this.tipFee == null || this.uomId == null) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'Price matrix is not available.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }

    if (this.scheduleId == 1) {
      if ((this.statusId == 1 || this.statusId == 8) && !this.feeCategoryIds?.includes(6)) {
        if (this.actualQuantity == null
          || this.actualDate == null){
          // || this.trailerNumber == null
          // || this.trailerNumber.trim() === '') {
          this.dialog.open(AlertDialogComponent, {
            data: {
              title: 'Alert',
              message: 'Actual Volume and Date Received are required !.'
            },
            disableClose: true,
            panelClass: 'delete-confirmation-dialog-nowrap'
          });
          return;
        }
      }
    } else {
      if ((this.statusId == 1 || this.statusId == 8) && this.feeCategoryId !== 6) {
        if (this.actualQuantity == null
          || this.actualDate == null) {
          this.dialog.open(AlertDialogComponent, {
            data: {
              title: 'Alert',
              message: 'Actual Quantity and Date Received are required !.'
            },
            disableClose: true,
            panelClass: 'delete-confirmation-dialog-nowrap'
          });
          return;
        }
      }
    }

    if (this.statusId == 8 && this.holdLoadOnComplete) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'Status cannot be set to Complete<br />if Hold Load is set !!.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    const scWorkOrderStr = this.scWorkOrder?.toString() || '';
    if (this.scheduleId != 1 && this.statusId == 8 && !this.disableSCWorkOrder 
      && (this.scWorkOrder == null || scWorkOrderStr.trim() == "")) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'Please enter SC Workorder # !!.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
      return;
    }
    

    this.onProceedToSave();
  }

  validateYear(event: any) {
    const value = event.target.value;
    if (!value) return;
    const parts = value.split('/');
    const yearPart = parts[parts.length - 1];

    if (yearPart && yearPart.length < 4) {
      this.actualDate = null;
    }
  }

  private scrollToFirstInvalidControl() {
    setTimeout(() => {
      this.cdr.detectChanges();
      const firstInvalid = document.querySelector('.mat-form-field-invalid');

      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const elementToFocus = firstInvalid.querySelector('mat-select, input') as HTMLElement;
        if (elementToFocus) {
          elementToFocus.focus();
        }
      }
    }, 100);
  }

  onProceedToSave(): void {
    var schedDate = '';
    if (this.scheduleId == 1) {
      schedDate = this.actualDate == null ? '' : formatDateTime(this.actualDate) ?? '';
    } else {
      schedDate = this.scheduleDate == null ? '' : formatDateTime(this.scheduleDate) ?? '';
    }
    if (this.scheduleId == 1) {
      this.adctrl.control.markAsTouched();
    } else {
      this.adctrl.control.markAsTouched();
      this.sdctrl.control.markAsTouched();
    }

    if (schedDate === null || schedDate === '' || this.actualDate === null) {
      return;
    }

    const nowISO = new Date();
    let finalActualDate: string;
    if (this.actualDate) {
      finalActualDate = formatDateTime(this.actualDate) ?? '';
    } else {
      finalActualDate = formatDateTime(nowISO) ?? '';
    }

    if (finalActualDate === null || finalActualDate === '') {
      return;
    }

    const formData: SaveFeedstockLoadScheduleRequest = {
      id: this.id ?? 0,
      generatorId: `${this.generatorId}`,
      streamId: this.streamId ?? 0,
      siteID: `${this.disposalSiteId}`,
      haulerId: `${this.haulerId}`,
      tankId: this.tankId,
      unitOfMeasure: this.uomId,
      projected_Quantity: this.projectedVolume,
      actualDate: finalActualDate,
      feeCategory: this.scheduleId == 1 ? null : this.feeCategoryId,
      tipFee: this.tipFeeCtrlDisabled ? null : this.tipFee,
      flatFee: this.flatFee,
      status: `${this.statusId}`,
      actual_Quantity: this.actualQuantity,
      driver: this.driverName,
      loadSlipNumber: this.loadSlipNumber,
      trailer_Number: normalizeNullableToString(this.trailerNumber),
      customerReferenceNo: normalizeNullableToString(this.customerReferenceNo),
      internalNotes: normalizeNullableToString(this.internalNotes),
      notesForHauler: normalizeNullableToString(this.notesForHauler),
      notesForCustomer: normalizeNullableToString(this.notesForCustomer),
      codNotes: normalizeNullableToString(this.codNotes),
      holdLoadOnComplete: this.holdLoadOnComplete,
      fS_LoadSchedule_AdditionalStreams: [],
      rpcTypesWithCount: [],
      scheduleDate: schedDate,
      feedstockStreamId: `${this.streamId}`,
      actual_Volume_Tons: this.actualTons,
      schedulingNotes: this.scheduleId == 4 ? normalizeNullableToString(this.schedulingNotes) : '',
      hauler: `${this.haulerId}`,
      ticket_Number: '',
      biology_Notes: '',
      dispatchOverride: '',
      cOD_Required: false,
      scheduleType: this.scheduleId,
      notesForDisposalSite: normalizeNullableToString(this.notesForDisposalSite),
      truckType: this.truckId,
      rebateUOM: this.ruomId,
      rebateQty: this.rebateQuantity,
      feeCategories: this.feeCategoryIds.length > 0 ? this.feeCategoryIds.join(',') : '',
      cancelReasonId: this.cancelReasonId,
      cancelReasonNotes: normalizeNullableToString(this.cancelReasonNotes),
      disposalMethodId: this.disposalMethodId,
      internalSiteHaulCostReason: this.internalSiteHaulCostReasonId,
      seal: this.seal ? `${this.seal}` : null,
      bol: this.bol ? `${this.bol}` : null,
      truck_Number: this.truck_Number ? `${this.truck_Number}` : null,
      isInvoiceReqForCancelledLoad: this.isInvoiceReqForCancelledLoad,
      priceMatrixId: this.priceMatrixId,
      divertedLoad: this.divertedLoad,
      scWorkOrderNo: this.scWorkOrder,
      haulingExpense: this.haulingExpense
    };

    const additionalStreamsRequest: SaveFeedStockLoadSchedule_AdditionalStreamsRequest[] =
      this.additionalStreamsDataSource.data.map(item => {
        const uomText = this.uoms.find(u => u.id === item.uom)?.name || '';
        return {
          id: `${item.id}`,
          fSLoadID: this.id || 0,
          streamID: item.streamID,
          streamName: item.streamName,
          uom: item.uom,
          uOMText: uomText,
          quantity: item.quantity,
          tipFee: item.tipFee,
          aD_RebateUOM: item.aD_RebateUOM,
          aD_RebateUOMText: this.ruoms.find(u => u.id === item.aD_RebateUOM)?.name || '',
          aD_RebateQty: item.aD_RebateQty,
          rebateValue: item.rebateValue,
          tons: item.tons,
          aPriceMatrixId: item.addtPMId
        };
      });

    formData.fS_LoadSchedule_AdditionalStreams = additionalStreamsRequest;
    formData.rpcTypesWithCount = (this.rpcTypesData ?? []).map(r => ({
      id: r.id < 0 ? 0 : r.id,
      rpcTypeId: r.rpcTypeId,
      rpCcount: r.rpCcount      
    }));

    console.log('Form data to save:', formData);

    this.feedstockService.saveLoadData(formData).subscribe({
      next: (response) => {
        console.log('Save successful:', response);
        this.dialogRef.close(true);
      }
    });
  }

  onReset(): void {
    if (this.task == "Add") {
      this.id = null;
      this.stid = null;
      this.siteTypeId = null;
      this.marketId = "-1";
      this.generatorId = null;
      this.streamId = null;
      this.disposalSiteId = null;
      this.haulerId = null;
      this.tankId = null;
      this.uomId = null;
      this.projectedVolume = null;
      this.tipFee = null;
      this.feeCategoryId = null;
      this.haulRevenue = null;
      this.flatFee = null;
      this.statusId = null;
      this.actualQuantity = null;
      this.driverName = '';
      this.loadSlipNumber = null;
      this.trailerNumber = '';
      this.customerReferenceNo = '';
      this.internalNotes = '';
      this.notesForHauler = '';
      this.notesForCustomer = '';
      this.codNotes = '';
      this.holdLoadOnComplete = false;
      this.feeCategoryIds = [];
      this.prevFeeCategoryIds = [];
      this.rpcTypesData = []
    }
    else {
      this.loadDataOnEditOrDuplicate(this.editresponse);
    }
    console.log('Form reset.');
  }

  onClose(): void {
    if (this.hasDocumentAttached) {
      this.dialogRef.close({ saved: false, hasAttachment: true, loadId: this.id });
    } else {
      this.dialogRef.close(false);
    }
  }

  onCancel(): void {
    this.onClose();
  }

  onKeydown(event: KeyboardEvent) {
    if (event.ctrlKey && event.metaKey) { return; }
    if (!/[0-9\/]/.test(event.key) && event.key.length === 1) {
      event.preventDefault();
    }
  }

  dateformat(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if (!value) return;
    const parts = value.split('/');
    if (parts.length !== 3) return;

    let [month, day, year] = parts.map(part => part.padStart(2, '0'));
    if (month.length === 1) month = '0' + month;
    if (day.length === 1) day = '0' + day;
    if (year.length === 2) year = '20' + year;
    input.value = `${month}/${day}/${year}`;
  }

  filterMarkets(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredMarkets = [...this.markets];
    } else {
      this.filteredMarkets = this.markets.filter(
        market => market.regionName.toLowerCase().includes(searchTerm)
      );
    }
  }

  filterGenerators(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredGenerators = [...this.generators];
    } else {
      this.filteredGenerators = this.generators.filter(
        g => g.customerName.toLowerCase().includes(searchTerm)
      );
    }
  }

  filterStreams(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredstreams = [...this.streams];
    } else {
      this.filteredstreams = this.streams.filter(
        g => g.name.toLowerCase().startsWith(searchTerm)
      );
    }
  }

  filterFeeCats(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    const selectedFeeCategoryIds = this.feeCategoryIds;
    if (!searchTerm) {
      this.filteredFeeCategories = [...this.feeCategories];
    } else {
      this.filteredFeeCategories = this.feeCategories.filter(
        g => g.category.toLowerCase().includes(searchTerm) || selectedFeeCategoryIds.includes(g.id)
      );
    }
  }

  filterFeeCategory(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    const selectedFeeCategoryIds = this.feeCategoryIds;
    if (!searchTerm) {
      this.filteredFeeCategories = [...this.feeCategories];
    } else {
      this.filteredFeeCategories = this.feeCategories.filter(
        g => g.category.toLowerCase().includes(searchTerm) || selectedFeeCategoryIds.includes(g.id)
      );
    }
  }

  filterSFeeCategory(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredFeeCategories = [...this.feeCategories];
    } else {
      this.filteredFeeCategories = this.feeCategories.filter(
        g => g.category.toLowerCase().includes(searchTerm)
      );
    }
  }

  filterSites(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filtereddisposalSites = [...this.disposalSites];
    } else {
      this.filtereddisposalSites = this.disposalSites.filter(
        g => g.siteName.toLowerCase().startsWith(searchTerm)
      );
    }
  }

  filterHaulers(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredhaulers = [...this.haulers];
    } else {
      this.filteredhaulers = this.haulers.filter(
        g => g.name && g.name.toLowerCase().startsWith(searchTerm)
      );
    }
  }

  filterInternalSiteHaulCostReasons(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredInternalSiteHaulCostReasons = [...this.internalSiteHaulCostReasons];
    } else {
      this.filteredInternalSiteHaulCostReasons = this.internalSiteHaulCostReasons.filter(
        g => g.name && g.name.toLowerCase().startsWith(searchTerm)
      );
    }
  }

  onMarketDropdownOpened(isOpen: boolean, searchInput: HTMLInputElement): void {
    if (isOpen) {
      setTimeout(() => {
        searchInput.focus();
      }, 0);
    } else {
      this.filteredMarkets = [...this.markets];
      searchInput.value = '';
    }
  }

  onGeneratorDropdownOpened(isOpen: boolean, searchInput: HTMLInputElement): void {
    if (isOpen) {
      setTimeout(() => {
        searchInput.focus();
      }, 150);
    } else {
      this.filteredGenerators = [...this.generators];
      searchInput.value = '';
    }
  }

  onStreamDropdownOpened(isOpen: boolean, searchInput: HTMLInputElement): void {
    if (isOpen) {
      setTimeout(() => {
        searchInput.focus();
      }, 150);
    } else {
      this.filteredstreams = [...this.streams];
      searchInput.value = '';
    }
  }

  onSiteDropdownOpened(isOpen: boolean, searchInput: HTMLInputElement): void {
    if (isOpen) {
      setTimeout(() => {
        searchInput.focus();
      }, 0);
    } else {
      this.filtereddisposalSites = [...this.disposalSites];
      searchInput.value = '';
    }
  }

  preventArrowKeyChange(event: KeyboardEvent): void {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }

  openAddorEditStreamDialog(rowId: number, row: FeedStockLoadScheduleAdditionalStreamsResponse | null, isEdit: boolean): void {
    if (this.canOpenAdditionalStreams) {
      var existingAdditionalStreamIds = this.additionalStreamsDataSource.data.map(stream => stream.streamID);
      const dialogRef = this.dialog.open(AddeditAdditionalstreamsComponent, {
        disableClose: true,
        data: {
          streamid: this.streamId,
          genId: this.generatorId,
          schedType: this.scheduleId,
          marketid: this.marketId,
          fsLoadId: this.id,
          fsAddtStreamId: rowId,
          siteId: this.disposalSiteId,
          haulid: Number(this.haulerId?.split('-')[1]),
          existingStreamIds: existingAdditionalStreamIds,
          editStream: row?.streamID,
          editUOM: row?.uom,
          editquantity: row?.quantity,
          tipfee: row?.tipFee,
          editRebateUOM: row?.aD_RebateUOM,
          editRebateQuantity: row?.aD_RebateQty,
          editRebateValue: row?.rebateValue,
          isEdit: isEdit,
          tons: row?.tons,
          actualDate: formatDateOnly(this.actualDate)
        },
        width: '650px',
        maxWidth: '650px',
      });

      dialogRef.afterClosed().subscribe((result: FeedStockLoadScheduleAdditionalStreamsResponse) => {
        if (result) {
          const currentData = this.additionalStreamsDataSource.data;
          if (row) {
            const index = currentData.findIndex(item => item.id === row.id);
            if (index > -1) {
              currentData[index] = result;
            }
          } else {
            currentData.push(result);
          }
          this.additionalStreamsDataSource.data = [...currentData];
        }
      });
    } else {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'Alert',
          message: 'No Additional Streams Available for this customer.'
        },
        disableClose: true,
        panelClass: 'delete-confirmation-dialog-nowrap'
      });
    }
  }

  deleteAddtStreams(row: FeedStockLoadScheduleAdditionalStreamsResponse) {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Additional Stream ${row.streamName}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true,
    }).afterClosed().subscribe(result => {
      if (result) {
        if (row.id !== null && row.id !== undefined) {
          this.additionalStreamsDataSource.data = this.additionalStreamsDataSource.data.filter(item => item.id !== row.id);
          if (row.id > 0) {
            this.feedstockService.deleteFSLoadAdditionalStreamsById(row.id).subscribe({
              next: async (response) => {
                console.log("Additional Stream deleted successfully", response);
              }
            });
          }
        }
      }
    });
  }

  onStatusDropdownOpened(): void {
    const currentStatus = this.fsStatusList.find(s => s.id === this.statusId);
    this.prevStatusId = currentStatus ? currentStatus.id : null;
  }

  onStatusChange(newStatusDescription: number, manualChange: boolean = false): void {
    console.log("fs status list", this.fsStatusList);
    const newStatusOption = this.fsStatusList.find(s => s.id === newStatusDescription);
    this.setShowCancelRowVisibility(newStatusOption?.description);
    const newStatusId = newStatusOption ? newStatusOption.id : null;
    
    this.statusId = newStatusId;
    this.prevStatusId = newStatusId;
    if(manualChange){
      if(this.statusId == 1){
        const now = new Date();

        if (this.actualDate) {
          const isSameDay = this.actualDate.getFullYear() === now.getFullYear() &&
            this.actualDate.getMonth() === now.getMonth()    &&
            this.actualDate.getDate() === now.getDate();

          if (isSameDay) {
            this.preAcceptedActualDate = new Date(this.actualDate);
            
            const updated = new Date(this.actualDate);
            updated.setHours(now.getHours(), now.getMinutes(), 0, 0);
            this.actualDate = updated;
          }
        }
      }else{
        if (this.preAcceptedActualDate) {
          this.actualDate = new Date(this.preAcceptedActualDate);
          this.prevActualDate = null; // clear backup
        }
      }      
    }

    if (newStatusOption?.id == 2 || newStatusOption?.id == 3
      || newStatusOption?.id == 5) {
      this.isInvoiceReqForCancelledLoadDisabled = false;
    } else {
      this.isInvoiceReqForCancelledLoadDisabled = true;
      //this.setControl('invoiceThisLoad', true);
    }
  }

  setShowCancelRowVisibility(statusDescription: string | undefined | null): void {
    if (statusDescription === 'VR Cancelled' || statusDescription === 'Customer Cancelled' || statusDescription === 'Rejected') {
      this.showCancelRow = true;
    } else {
      this.showCancelRow = false;
      this.cancelReasonId = null;
      this.cancelReasonNotes = null;
    }
  }

  onFeeCategoriesChange(selectedFeeCategoryIds: number[] | null, manualChange: boolean = false): void {
    const feeCategoryIds = Array.isArray(selectedFeeCategoryIds) ? selectedFeeCategoryIds : [];
    const includesCategory = feeCategoryIds.includes(6);
    const hasLTL = feeCategoryIds.includes(this.FEE_LTL);
    const hasFTL = feeCategoryIds.includes(this.FEE_FTL);

    if (hasLTL && hasFTL) {
      const justAddedFTL = !this.prevFeeCategoryIds.includes(this.FEE_FTL) && hasFTL;

      this.feeCategoryIds = justAddedFTL
        ? feeCategoryIds.filter(id => id !== this.FEE_FTL)  // FTL just added → remove it
        : feeCategoryIds.filter(id => id !== this.FEE_LTL); // LTL just added → remove it

      if (manualChange) {
        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Alert',
            message: 'You must select either Environment Fee LTL or Environment Fee FTL, not both.'
          },
          disableClose: true,
          panelClass: 'delete-confirmation-dialog-nowrap'
        });
      }

      // Force mat-select to reflect the reverted value
      setTimeout(() => this.cdr.detectChanges());
      return;
    }

    this.prevFeeCategoryIds = [...feeCategoryIds];

    if (includesCategory) {
      this.isProjectedQuantityEnabled = false;
      this.isFlatFeeDisabled = false;
      //this.setControl('flatFee', false);
    } else {
      this.flatFee = null;
      this.isFlatFeeDisabled = true;
      //this.setControl('flatFee', true);
    }
  }

  onFeeCategoryChange(selectedFeeCategoryId: number | null): void {
    const includesCategory = selectedFeeCategoryId == 6;

    if (includesCategory) {
      if (this.projectedVolume !== null) {
        this.prevprojectedVolume = this.projectedVolume;
      }
      this.isActualQuantityDisabled = false;
      this.isProjectedQtyDisabled = true;
      this.isActualTonsEnabled = true;
      this.isFlatFeeDisabled = false;
      //this.setControl('flatFee', false);
    } else {
      this.isActualTonsEnabled = false;
      this.isProjectedQtyDisabled = false;
      if (this.prevprojectedVolume !== null) {
        this.projectedVolume = this.prevprojectedVolume;
      }
      this.flatFee = null;
      this.isFlatFeeDisabled = true;
      //this.setControl('flatFee', true);
    }
  }

  onActualTonChange(): void {
    if ((this.scheduleId == 2 || this.scheduleId == 4) && this.uomId === 2) {
      const tonsValue: unknown = this.actualTons;
      if (tonsValue === null || tonsValue === undefined || tonsValue === '') {
        this.actualQuantity = null;
      } else {
        const normalizedTons = Number(tonsValue);
        this.actualQuantity = Number.isFinite(normalizedTons) ? normalizedTons : null;
      }
    }
  }

  trackById(index: number, item: CancelReasonResponse): number {
    return item.id;
  }

  isStatusOptionDisabled(status: string): boolean {
    return status === 'Invoiced';
  }

  get isScheduleTypeNotAD(): boolean {
    return this.scheduleId === 2 || this.scheduleId === 4;
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, type: number): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;

    val = val = numericInputLimit(event, maxValue, maxDecimals);

    this.displayValue.set(val);
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.';
    const parsedValue = maxDecimals === 0 ? parseInt(val, 10) : parseFloat(val);
    const finalValue = isValueEmpty ? null : parsedValue;

    switch (type) {
      case 1: this.flatFee = finalValue; break;
      case 2: this.projectedVolume = finalValue; break;
      case 3: this.actualQuantity = finalValue; break;
      case 4: this.actualTons = finalValue; break;
      case 5: this.loadSlipNumber = finalValue; break;
      case 6: this.rebateQuantity = finalValue; break;
      //case 7: this.seal = finalValue; break;
      //case 8: this.bol = finalValue; break;
      case 9: this.haulingExpense = finalValue; break;
      case 10: this.scWorkOrder = finalValue; break;
    }
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
          input.value = val;
      }
    });
  }

  openAttachDocuments(): void {
    const key = `documents_${this.id}`;
    localStorage.removeItem(key);

    const dialogRef = this.dialog.open(DeepackAttachDocumentsComponent, {
      panelClass: 'attachDocumentsDialog',
      disableClose: true,
      data: {
        loadScheduleId: this.id,
        screenTypeId: '0',
        name: this.workOrderNumber,
        disableAddMoreFiles: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //this.onSearch();
        this.hasDocumentAttached = true;
      }
    });
  }

  openViewDocsDialog(): void {
    const dialogRef = this.dialog.open(ViewDocumentsComponent, {
      //panelClass: 'viewDocsDialog',
      disableClose: true,
      data: {
        loadScheduleId: this.id,
        screenTypeId: '0',
        name: this.workOrderNumber,
        canShowGridActions: true//this.loadSchedulePermissions().ShowDocumentDeleteButton
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        //row.loadSlip = false;
  
        // this.dataSource.data = this.dataSource.data.map(x =>
        //   x.id === row.id ? { ...x, loadSlip: false } : x
        // );
      }
    });
  }  

  openRPC(): void {
    const dialogRef = this.dialog.open(AddEditRpcComponent, {
      disableClose: true,
      maxWidth: "750px",
      width: "750px",
      data: {
        loadScheduleId: this.id,
        name: this.workOrderNumber,
        gridData: this.rpcTypesData ?? []
      }
    });
    dialogRef.afterClosed().subscribe((result: RPCTypesTableType[] | null) => {
      if(Array.isArray(result)){
        this.rpcTypesData = result;
      }
    });
  }

  applyPermissionsToForm(flags: LoadScheduleControlFlags): void {    
    this.ctrlpermissions = { ...flags };
    this.cdr.detectChanges();
  }

  private enableControl(name: string): void {
    const permissionLocked = (this.ctrlpermissions as any)[name];
    if (permissionLocked === true) return;    // permission says locked — never override
    (this.ctrlpermissions as any)[name] = false;   // disabled=false → enabled in template
    this.cdr.detectChanges();
  }

  private disableControl(name: string): void {
    (this.ctrlpermissions as any)[name] = true;    // disabled=true → disabled in template
    this.cdr.detectChanges();
  }

  private setControl(name: string, enabled: boolean): void {
    enabled ? this.enableControl(name) : this.disableControl(name);
  }
}
